import React, { useEffect, useState } from 'react';
import './RelatoriosSalvos.css';
import Menu from '../../components/menu/Menu';
import NavBar from '../../components/navbar/NavBar';
import { useParams } from 'react-router-dom';
import SavedReportTable from '../../components/SavedReportTable/SavedReportTable';
import ReactLoading from 'react-loading';

function RelatoriosSalvos() {
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { clientId } = useParams();
    const [isMenuExpanded, setIsMenuExpanded] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleToggleMenu = (expanded) => {
        setIsMenuExpanded(expanded);
    };

    return (
        <div className={`relatorios-salvos ${isMenuExpanded ? 'menu-expanded' : 'menu-collapsed'}`}>
            {successMessage && <div className="success-message">{successMessage}</div>}
            {isLoading && (
                <div className="loading-overlay active">
                    <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
                </div>
            )}
            {errorMessage && <div className="error-message">{errorMessage}</div>}
            <div className="menu-relatorios-salvos">
                <Menu onToggleMenu={handleToggleMenu} />
            </div>
            <div className="navbar-relatorios-salvos">
                <NavBar />
            </div>
            <div className="relatorios-salvos-container">
                <h1 className='text-relatorios-salvos'>Relatórios Salvos</h1>

                <SavedReportTable />
            </div>
        </div>
    );              
}

export default RelatoriosSalvos;
